/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef, useState } from 'react';
import { SearchFilterSizeGenderSelectDesktop } from 'search/components/searchGrid/SearchFilterSizeGenderSelectDesktop';
import { sortConditionTitles, sortGender, sortSizeTitles } from 'search/utils/sizeFilterUtils';
import { ConsumerSearchFilterGrid } from 'search/components/searchGrid/SearchFilterGrid';
import { SIZE_MAP } from 'shared/enums/Size';
import { useLocation } from 'shared/hooks/useLocation';
import { ConsumerSearchFilterConditionOptionDesktop } from 'search/components/searchGrid/SearchFilterConditionOptionDesktop';
import ConsumerSearchFilterPriceDesktop from 'search/components/searchGrid/ConsumerSearchFilterPriceDesktop';
import { useEventContext } from 'tracking/hooks/useEventContext';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { getAppliedFilters } from 'shared/utils/gridEventTrackingUtils';
import { useStoreSelector } from 'store/hooks/storeHooks';
import { filterKeysToExclude } from 'search/utils/filterKeysToExclude';
import SearchFilterSubCollectionDesktop from 'search/components/searchGrid/SearchFilterSubCollectionDesktop';
import { FUTURE, PRESENT } from 'timeline/enums/constants';
import {
  CONDITION_DESCRIPTION,
  NAME_DISPLAY,
  QUERY_NAME_DISPLAY,
  SORT_FILTER_MAP,
  TopTitleFilter,
} from './constant';
import Text from '../Text';
import {
  appendZero,
  colorsPalette,
  colorSwatch,
  getSortedFilterList,
  getTimeStamps,
  mergeColorsByName,
} from './utils/gridUtils';
import { UnorderedList } from '../UnorderedList';
import { getFilters } from './utils/getFilters';

const ALL_VALID_COUNTRIES = new Set(['US', 'EU', 'FR', 'IT', 'JP', 'UK', 'CA']);

function isValidSize(numString: string, options: { isApparel: boolean }) {
  const num = Number.parseFloat(numString);

  if (!options?.isApparel && (Number.isNaN(num) || (!Number.isNaN(num) && (num > 25 || num < 0)))) {
    return false;
  }

  return !Number.isNaN(num) && (num % 1 === 0 || num % 1 === 0.5);
}

export const SizeOrder = [
  'xxxs',
  'xxxs/xxs',
  'xxs',
  'xxs/xs',
  'xs',
  'xs/s',
  's',
  's/m',
  'm',
  'm/l',
  'l',
  'l/xl',
  'xl',
  'xl/xxl',
  'xxl',
  'xxl/xxxl',
  'xxxl',
  '4xl',
];

export const sortByShirtSizeOrder = (sizeArray: any[]) => {
  sizeArray.sort((a, b) => {
    if (
      SizeOrder.indexOf(a.display_name?.toLowerCase()) <
      SizeOrder.indexOf(b.display_name?.toLowerCase())
    ) {
      return -1;
    }
    if (
      SizeOrder.indexOf(b.display_name?.toLowerCase()) <
      SizeOrder.indexOf(a.display_name?.toLowerCase())
    ) {
      return 1;
    }
    return 0;
  });
  return sizeArray;
};

export const FilterItem = ({
  name,
  kids,
  onClick,
  isColor,
  isYearsList,
  isRootCategory,
  isProductType,
  isSort,
  sizeList,
  isSizeList,
  isGender,
  topTitle,
}: {
  topTitle?: string;
  name: string;
  kids?: any[];
  open?: boolean;
  onClick?: (e: any) => void;
  isColor?: string;
  isYearsList?: boolean;
  isProductType?: boolean;
  isActivityType?: boolean;
  isRootCategory?: boolean;
  isSort?: string;
  sizeList?: any[];
  isSizeList?: boolean;
  isGender?: boolean;
}) => {
  const router = useRouter();
  const { selectedCountryCode } = useLocation();
  const eventTrackingEventContext = useEventContext();

  const { query } = router || {};

  const queryName: any = isColor
    ? 'colors'
    : isGender
      ? 'genders'
      : isProductType
        ? 'types'
        : !isRootCategory
          ? 'activities'
          : isYearsList
            ? 'releaseYears'
            : topTitle === 'brandsList'
              ? 'brands'
              : 'categories';

  // TODO: allow the backend to give us the list of activities avaialble for sneakers in the current search
  const hasKids = kids && kids.length > 0;

  const getDataQa = useCallback(
    (str: string) => {
      // eslint-disable-next-line unicorn/no-useless-undefined
      if (!str) return undefined;

      const t = str.toLowerCase();
      if (isSort) {
        if (t === 'recently released sneakers') {
          return 'recently_released_sneakers_sort_option';
        }

        if (t === 'new in apparel') {
          return 'new_in_apparel_sort_option';
        }

        if (t === 'popular') {
          return 'popular_sort_option';
        }

        if (t === 'price (low - high)') {
          return 'price_low_high_sort_option';
        }
        if (t === 'price (high - low)') {
          return 'price_high_low_sort_option';
        }
        return `${t}_sort_option`;
      }

      return `${t}_filter_option`;
    },
    [isSort],
  );
  const genders = sizeList
    ?.map((item) => item?.name?.split('_')?.[1]?.trim?.() || '')
    .filter((i) => i)
    .sort(sortGender);
  const [selectedGender, setSelectedGender] = useState(genders?.[0] || '');

  const handleSelectChange = useCallback((value) => {
    setSelectedGender(value);
  }, []);

  useEffect(() => {
    setSelectedGender(genders?.[0] || '');
  }, [sizeList]);

  const sizeGridData = useCallback(() => {
    const sizeListOptions = sizeList?.find(
      (s) => selectedGender === s?.name?.split('_')?.[1]?.trim?.() || '',
    );

    const country = ALL_VALID_COUNTRIES.has(selectedCountryCode.toUpperCase())
      ? selectedCountryCode.toUpperCase()
      : 'US';

    let allOptions = sizeListOptions?.availableSizesList?.map((item) => {
      const optValue = `${name === 'shoes' ? `${country}_` : 'universal_'}${name === 'shoes' ? 'sneakers' : name}_${selectedGender}_${SIZE_MAP[item.name] || item.name}`;
      return {
        value: optValue,
        status: new Set(((query.sizes || '') as string).split(',')).has(optValue) ? 'selected' : '',
        display_name: (SIZE_MAP[item.name] || appendZero(item.name)).toUpperCase(),
      };
    });

    allOptions =
      name === 'shoes'
        ? allOptions
            ?.filter((a) => isValidSize(a.display_name, { isApparel: false }))
            ?.sort((a, b) => a.display_name - b.display_name)
        : sortByShirtSizeOrder(
            allOptions?.filter((a) =>
              Object.values(SIZE_MAP).includes(a.display_name?.toLowerCase()),
            ) || [],
          );

    return allOptions;
  }, [genders, name, selectedGender, sizeList, selectedCountryCode]);

  const selectedTypes = new Set(((query[queryName] || '') as string).split(','));
  selectedTypes.delete('');

  //  check the sortType to selec
  let selectedSort = isSort;
  const categoriesNow = ((query.categories as string) || '')?.trim() || '';
  const typesNow = ((query.types as string) || '')?.trim() || '';
  if (categoriesNow === 'Apparel' && query.sortType === 'recently_released') {
    selectedSort = 'new_in_apparel';
  } else if (
    query.sortType === 'recently_released' &&
    typesNow === 'sneakers' &&
    categoriesNow === 'shoes'
  ) {
    selectedSort = 'recently_released_sneakers';
  } else {
    selectedSort = query.sortType as string;
  }

  const isSelected = isSort ? selectedSort === isSort : selectedTypes.has(name);
  const [open, setOpen] = useState(!isSort ? isSelected : false);

  useEffect(() => {
    setOpen(!isSort ? isSelected : false);
  }, [isSelected, isSort]);

  if (isColor && !colorsPalette.includes(isColor)) {
    return null;
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      onClick={(e) => {
        if (isSizeList) {
          setOpen((p) => !p);
        } else {
          onClick?.(e);
        }
      }}
      style={{
        marginBottom: isProductType && open ? '16px' : '0px',
      }}
      className={isSort ? 'tw-group hover:tw-underline tw-underline-offset-2 ' : ''}
    >
      <div
        className="tw-mb-1 tw-underline-offset-2 tw-cursor-pointer filter-item-wrapper"
        style={{
          textDecoration:
            open || isSelected || (!selectedSort && isSort === 'popular') ? 'underline' : '',
          textAlign: 'right',
          marginBottom: isColor ? '0px' : '',
        }}
      >
        <div
          className="tw-flex tw-items-center tw-gap-0"
          style={{
            justifyContent: 'end',
            overflowWrap: 'anywhere',
          }}
        >
          {isColor && colorsPalette.includes(isColor) ? (
            <div className="tw-flex tw-items-center tw-gap-2 tw-group">
              <div
                className={`tw-capitalize ${isSelected ? 'tw-block' : 'tw-hidden group-hover:tw-block'}`}
              >
                {isColor}
              </div>
              <div
                className="tw-w-[20px] tw-h-[20px] hover:tw-cursor-pointer"
                data-qa="color_filter_swatch"
                style={{
                  backgroundColor: colorSwatch[isColor] || isColor,
                  backgroundImage:
                    isColor === 'multi-color'
                      ? 'url("https://cms-cdn.goat.com/750/567e15a619be-4918-ce11-49d1-06ca4b9e.png")'
                      : 'none',
                  backgroundSize: 'contain',
                }}
              />
            </div>
          ) : (
            <Text
              className="first-letter:tw-uppercase tw-border-none tw-p-0 tw-m-0 text-hover-underline tw-text-right"
              as="button"
              style={{
                fontWeight:
                  isSelected && !isSort && !isGender && topTitle !== 'brandsList'
                    ? 'bold'
                    : 'normal',
                textDecoration: isSelected && !isSort ? 'underline' : 'none',
                maxWidth: 148,
              }}
              data-qa={getDataQa(name)}
            >
              {isSizeList && name === 'shoes' ? 'Sneakers' : name?.replaceAll('activity:', ' ')}
            </Text>
          )}
        </div>
      </div>
      {/* SIZE DROPDOWNS HERE */}
      {open && isSizeList && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            flexDirection: 'column',
            alignItems: 'end',
            paddingBottom: '32px',
          }}
        >
          <SearchFilterSizeGenderSelectDesktop
            options={genders}
            handleSelectChange={handleSelectChange}
            selectedGender={selectedGender}
          />
          <ConsumerSearchFilterGrid
            filterOptions={sizeGridData()}
            name="size_converted"
            handleClick={(value) => {
              let newQuery: any = { ...query };
              const selectedSizes = new Set(((query.sizes || '') as string).split(','));
              selectedSizes.delete('');

              const newTypes = new Set(selectedSizes);
              if (newTypes.has(value as string)) {
                newTypes.delete(value as string);
              } else {
                newTypes.add(value as string);
              }

              if (newTypes.size === 0) {
                delete newQuery.sizes;
              } else {
                newQuery = {
                  ...newQuery,
                  sizes: [...newTypes].join(','),
                };
              }

              void router.push(
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                `${window.location.pathname}?${new URLSearchParams({ ...newQuery, pageNumber: '1' }).toString()}`,
              );
            }}
          />
        </div>
      )}

      {/* EVERY OTHER DROPDOWN HERE */}

      {open &&
        hasKids &&
        kids.map((kid) => {
          // eslint-disable-next-line no-extra-boolean-cast, @typescript-eslint/no-shadow
          const queryName = Boolean(kid.activitiesList)
            ? 'types'
            : !isRootCategory
              ? 'activities'
              : 'categories';

          // eslint-disable-next-line @typescript-eslint/no-shadow
          const selectedTypes = new Set(((query[queryName] || '') as string).split(','));
          return (
            <FilterItem
              key={kid.name || 'kid'}
              name={kid.name}
              kids={kid.activitiesList}
              isActivityType={!isRootCategory && !kid.activitiesList}
              isProductType={Boolean(kid.activitiesList)}
              onClick={(e) => {
                let newQuery: any = { ...query };
                e.preventDefault();
                e.stopPropagation();
                const newTypes = new Set(selectedTypes);
                if (newTypes.has(kid.name)) {
                  newTypes.delete(kid.name);
                  // if it's type, delete all activities associated with it
                  if (kid.activitiesList) {
                    const allkidsSet = new Set(((query.activities || '') as string).split(','));

                    kid.activitiesList.forEach((activity: any) => {
                      allkidsSet.delete(activity.name);
                    });

                    newQuery = {
                      ...newQuery,
                      activities: [...allkidsSet].join(','),
                    };
                  }
                } else {
                  newTypes.add(kid.name);
                }
                newQuery = {
                  ...newQuery,
                  [queryName]: [...newTypes].join(','),
                };

                sendTrackingEvent('FILTER_APPLY_TAP', {
                  event_context: eventTrackingEventContext,
                  filter_name: queryName,
                  service_name: 'consumer_search',
                  filter_selection: kid.name,
                  ...(getAppliedFilters(newQuery) && {
                    applied_filters: getAppliedFilters(newQuery),
                  }),
                  ...(query?.query && { search_string: query.query.toString() }),
                });

                void router.push(
                  `${window.location.pathname}?${new URLSearchParams({ ...newQuery, pageNumber: '1' }).toString()}`,
                );
              }}
            />
          );
        })}
    </div>
  );
};

export const DesktopFilterSidebar = ({
  resetQuery,
  onSelectSection,
  sideBarState,
  filters: _filters,
  pageFilters,
  hideMetadata = false,
  subCollections = [],
  timelineData = {},
}: {
  filters?: any;
  resetQuery?: () => void;
  onSelectSection: (newState: any) => void;
  sideBarState: any;
  collectionDetails?: any;
  pageFilters?: any;
  hideMetadata?: boolean;
  subCollections?: any[];
  timelineData?: { isTimelinePath?: boolean; timelineType?: string };
}) => {
  const filters = getFilters({ filters: _filters, pageFilters });

  const router = useRouter();
  const { query } = router || {};
  const { selectedCountryCode } = useLocation();
  const eventTrackingEventContext = useEventContext();
  const hasTouchedFilters = useRef<any>(false);
  const { isTimelinePath, timelineType } = timelineData;
  const isFutureOrPresent = timelineType === FUTURE || timelineType === PRESENT;
  const sortOptions = isTimelinePath
    ? isFutureOrPresent
      ? ['popular', 'new_in', 'upcoming_releases']
      : ['popular', 'date']
    : [
        'popular',
        'recently_released_sneakers',
        'new_in_apparel',
        'price_low_high',
        'price_high_low',
      ];

  const { currentTheme } = useStoreSelector((state) => state.pageLayout);

  const hasNoQuery = useCallback(
    () =>
      Object.keys(query || {}).filter(
        (q) =>
          q !== 'query' &&
          q !== 'pageNumber' &&
          q !== 'slug' &&
          q !== 'showCollection' &&
          !filterKeysToExclude.has(q),
      ).length === 0,
    [query],
  );

  const sortedFilterList = useCallback(
    (title) => {
      return getSortedFilterList(filters[title], title);
    },
    [filters],
  );

  const getQaData = useCallback((str: string) => {
    // eslint-disable-next-line unicorn/no-useless-undefined
    if (!str) return undefined;

    const t = str.toLowerCase();
    if (t === 'instant') {
      return `instant_ship_filter_option`;
    }

    if (t === 'under retail') {
      return `under_retail_filter_option`;
    }

    if (t === 'available now') {
      return `available_now_filter_option`;
    }
    return `${t}_filter_option`;
  }, []);

  // New taxonomy

  const hasApparels = useCallback(() => {
    const apparel =
      filters?.productCategoriesList?.some((category: any) => category.name === 'Apparel') ||
      (query?.categories || '')?.length === 0 ||
      query?.categories?.includes('apparel') ||
      query?.categories?.includes('Apparel');
    return apparel;
  }, [query, filters]);

  const hasSneakers = useCallback(() => {
    const sneakers =
      filters?.productCategoriesList?.some((category: any) => category.name === 'Footwear') ||
      (query?.categories || '')?.length === 0 ||
      (query?.categories?.includes('footwear') && (query?.types || '').length === 0) ||
      (query?.categories?.includes('Footwear') && (query?.types || '').length === 0) ||
      query?.types?.includes('sneakers');

    return sneakers;
  }, [query, filters]);

  useEffect(() => {
    // scroll top if header is larger
    const sidebar = document.querySelector('#sidebar');
    if (sidebar) {
      sidebar.scrollTo({ top: 700, behavior: 'smooth' });
    }
  }, []);

  return (
    <div
      className="tw-pt-[78px] tw-pr-4 tw-pb-[160px] tw-overflow-scroll no-scrollbar "
      id="sidebar"
      style={{
        backgroundColor: currentTheme?.backgroundColor || '#FFF',
        paddingTop: hideMetadata ? '0px' : '78px',
      }}
    >
      {/* sort first */}
      <div className="tw-pb-6">
        {Object.keys(SORT_FILTER_MAP).map((sort: string) => {
          if (!sortOptions.includes(sort)) {
            return null;
          }

          if (
            (sort === 'new_in_apparel' && !hasApparels()) ||
            (sort === 'recently_released_sneakers' && !hasSneakers())
          ) {
            return null;
          }

          return (
            <FilterItem
              key={sort}
              name={SORT_FILTER_MAP[sort].name}
              isSort={sort}
              onClick={() => {
                let newQuery = {};

                switch (sort) {
                  case 'new_in_apparel':
                    hasTouchedFilters.current = false;
                    newQuery = {
                      categories: 'Apparel',
                      sortType: SORT_FILTER_MAP[sort].key,
                      pageNumber: 1,
                      query: query.query || '',
                    };
                    break;
                  case 'recently_released_sneakers':
                    hasTouchedFilters.current = false;
                    newQuery = {
                      productTypes: 'sneakers',
                      categories: 'footwear',
                      sortType: SORT_FILTER_MAP[sort].key,
                      releaseDateStart: getTimeStamps({
                        year: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).getFullYear(),
                        month: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).getMonth(),
                        day: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).getDate(),
                      }),
                      releaseDateEnd: getTimeStamps({
                        year: new Date(Date.now()).getFullYear(),
                        month: new Date(Date.now()).getMonth(),
                        day: new Date(Date.now()).getDate(),
                      }),
                      pageNumber: 1,
                      query: query.query || '',
                    };
                    break;
                  case 'upcoming_releases':
                    newQuery = {
                      ...query,
                      sortType: SORT_FILTER_MAP[sort].key,
                      releaseDateStart:
                        timelineType === PRESENT
                          ? getTimeStamps({
                              year: new Date(Date.now()).getFullYear(),
                              month: new Date(Date.now()).getMonth(),
                              day: new Date(Date.now()).getDate() + 1,
                            })
                          : getTimeStamps({
                              year: new Date(Date.now()).getFullYear(),
                              month: new Date(Date.now()).getMonth() + 1,
                              day: 1,
                            }),
                      releaseDateEnd:
                        timelineType === PRESENT
                          ? getTimeStamps({
                              year: new Date(Date.now()).getFullYear(),
                              month: new Date(Date.now()).getMonth(),
                              day: new Date(
                                new Date(Date.now()).getFullYear(),
                                new Date(Date.now()).getMonth() + 1,
                                0,
                              ).getDate(),
                            })
                          : getTimeStamps({
                              year: new Date(Date.now()).getFullYear() + 1,
                              month: new Date(Date.now()).getMonth() + 1,
                              day: new Date(
                                new Date(Date.now()).getFullYear(),
                                new Date(Date.now()).getMonth() + 1,
                                0,
                              ).getDate(),
                            }),
                      pageNumber: 1,
                    };
                    break;
                  default:
                    if (hasTouchedFilters.current === false) {
                      delete query.categories;
                      delete query.types;
                      delete query.releaseDateStart;
                      delete query.releaseDateEnd;
                    }
                    newQuery = {
                      ...query,
                      sortType: SORT_FILTER_MAP[sort].key,
                    };
                    break;
                }
                sendTrackingEvent('FILTER_SORT_TAP', {
                  service_name: 'consumer_search',
                  event_context: eventTrackingEventContext,
                  sort_selection: sort,
                });
                void router.push(
                  `${window.location.pathname}?${new URLSearchParams({ ...newQuery, pageNumber: '1' }).toString()}`,
                );
              }}
            />
          );
        })}
      </div>

      {/* space to reset */}
      <div
        className="tw-mb-5 tw-text-right tw-cursor-pointer hover:tw-underline"
        onClick={() => {
          if (!hasNoQuery()) {
            hasTouchedFilters.current = false;
            resetQuery?.();
          }
        }}
        data-qa={hasNoQuery() ? '' : 'clear-filters'}
      >
        {hasNoQuery() ? '' : 'Reset'}
      </div>

      {/* subcollections if exist */}

      {subCollections?.length > 0 && (
        <div className="tw-text-right">
          <SearchFilterSubCollectionDesktop subCollections={subCollections} />
        </div>
      )}

      {/* brand category gender year */}

      {Object.keys(NAME_DISPLAY).map((topTitle: string) => {
        let currentFilters = sortedFilterList(topTitle);

        // Hide filter if it should not be visible
        switch (topTitle) {
          case 'price':
            if (!filters.maximumPriceCents && !filters.minimumPriceCents) {
              return null;
            }
            break;
          case 'inStock':
            if (!filters.maximumPriceCents) {
              return null;
            }
            break;
          case 'sale':
            if (
              !filters.underRetail ||
              (Array.isArray(query.categories)
                ? query.categories.some((cat) => cat.toLowerCase().includes('footwear'))
                : query.categories?.toLowerCase()?.includes('footwear'))
            ) {
              return null;
            }
            break;
          case 'underRetail':
            if (
              !filters.underRetail ||
              (Array.isArray(query.categories)
                ? query.categories.some((cat) => cat.toLowerCase().includes('apparel'))
                : query.categories?.toLowerCase()?.includes('apparel'))
            ) {
              return null;
            }
            break;
          default:
            if (!filters[topTitle]) {
              return null;
            }
        }

        // get query name eg: brands for brandsList
        const queryName = QUERY_NAME_DISPLAY[topTitle as TopTitleFilter] || topTitle;
        const isYearsList = queryName === 'releaseYears';
        const isSizeList = queryName === 'size';
        const isConditionList = queryName === 'conditions';
        const isPrice = topTitle === 'price';
        const isColorList = queryName === 'colors';

        const isBooleanTilte = ['instantShip', 'underRetail', 'inStock', 'sale'].includes(topTitle);

        if (isSizeList) {
          currentFilters = currentFilters
            ?.filter((size) => {
              const sizeUnit = size?.gendersList?.[0]?.name?.split('_')?.[0]?.trim?.();

              const currentUnit = ALL_VALID_COUNTRIES.has(selectedCountryCode.toUpperCase())
                ? selectedCountryCode.toUpperCase()
                : 'US';
              return (
                ['shoes', 'tops', 'bottoms', 'outerwear', 'dresses', 'belts'].includes(
                  ((size.name as string) || '')?.toLowerCase(),
                ) &&
                ((size.name === 'shoes' && currentUnit === sizeUnit) || sizeUnit === 'UNIVERSAL')
              );
            })
            .sort(sortSizeTitles);
        } else if (isConditionList) {
          currentFilters = currentFilters.sort(sortConditionTitles);
        } else if (isColorList) {
          currentFilters = mergeColorsByName([...(currentFilters || [])]);
        }

        const selectedTypes = new Set(((query[queryName] || '') as string).split(','));
        selectedTypes.delete('');

        if (!currentFilters) {
          return null;
        }
        if (
          isBooleanTilte &&
          (((topTitle === 'instantShip' || topTitle === 'underRetail') && !filters?.[topTitle]) ||
            (!hasApparels() && topTitle === 'sale'))
        )
          return null;

        return (
          <div className="tw-text-right" key={topTitle}>
            <div
              className="tw-underline-offset-2 tw-cursor-pointer filter-search-button"
              onClick={() => {
                if (!sideBarState[topTitle] && !isBooleanTilte) {
                  sendTrackingEvent('FILTER_EXPAND_TAP', {
                    service_name: 'consumer_search',
                    event_context: eventTrackingEventContext,
                    filter_name:
                      NAME_DISPLAY[topTitle as TopTitleFilter].toLowerCase() === 'category'
                        ? 'web_groups'
                        : NAME_DISPLAY[topTitle as TopTitleFilter].toLowerCase(),
                    ...(query?.query && { search_string: query.query.toString() }),
                  });
                }
                onSelectSection({
                  ...sideBarState,
                  [topTitle]: !sideBarState[topTitle],
                });
                if (isBooleanTilte) {
                  const newQuery: any = { ...query };

                  if (newQuery[topTitle] === 'true') {
                    delete newQuery[topTitle];
                  } else {
                    newQuery[topTitle] = 'true';
                  }

                  sendTrackingEvent('FILTER_APPLY_TAP', {
                    service_name: 'consumer_search',
                    event_context: eventTrackingEventContext,
                    filter_name: topTitle,
                    filter_selection: newQuery[topTitle],
                    ...(getAppliedFilters(newQuery) && {
                      applied_filters: getAppliedFilters(newQuery),
                    }),
                    ...(newQuery?.query && { search_string: newQuery.query.toString() }),
                  });

                  void router.push(
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    `${window.location.pathname}?${new URLSearchParams({ ...newQuery, pageNumber: '1' }).toString()}`,
                  );
                }
              }}
            >
              {!isPrice ? (
                <Text
                  className="tw-capitalize tw-pb-1 tw-cursor-pointer hover:tw-underline tw-border-none tw-p-0 tw-m-0 tw-group "
                  style={{
                    textDecoration: sideBarState[topTitle] || query[queryName] ? 'underline' : '',
                  }}
                  as="button"
                  data-qa={getQaData(NAME_DISPLAY[topTitle as TopTitleFilter].toLowerCase())}
                >
                  {NAME_DISPLAY[topTitle as TopTitleFilter]}
                </Text>
              ) : (
                <ConsumerSearchFilterPriceDesktop
                  name="price"
                  priceMax={filters?.maximumPriceCents?.amountCents || 0}
                  priceMin={filters?.minimumPriceCents?.amountCents || 0}
                  displayName="Price"
                />
              )}
            </div>
            {sideBarState[topTitle] &&
              !isBooleanTilte &&
              !isPrice &&
              (isConditionList ? (
                <UnorderedList
                  data-qa="search_filter_conditions_list"
                  style={{
                    marginBottom: 16,
                  }}
                >
                  {currentFilters.map((option) => (
                    <ConsumerSearchFilterConditionOptionDesktop
                      key={option.name}
                      handleClick={(value) => {
                        let newQuery: any = { ...query };
                        const selectedConditions = new Set(
                          ((query.conditions || '') as string).split(','),
                        );
                        selectedConditions.delete('');

                        const newTypes = new Set(selectedConditions);

                        if (newTypes.has(value)) {
                          newTypes.delete(value);
                        } else {
                          newTypes.add(value);
                        }

                        if (newTypes.size === 0) {
                          delete newQuery.conditions;
                        } else {
                          newQuery = {
                            ...newQuery,
                            conditions: [...newTypes].join(','),
                          };
                        }

                        void router.push(
                          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                          `${window.location.pathname}?${new URLSearchParams({ ...newQuery, pageNumber: '1' }).toString()}`,
                        );
                      }}
                      facetType="product_condition"
                      option={{
                        status: new Set(((query.conditions || '') as string).split(',')).has(
                          option.name,
                        )
                          ? 'selected'
                          : '',
                        value: option.name,
                        ...CONDITION_DESCRIPTION[option.name],
                      }}
                    />
                  ))}
                </UnorderedList>
              ) : (
                <div
                  className="tw-mb-4 tw-max-h-[180px] tw-overflow-y-scroll no-scrollbar tw-flex tw-flex-col "
                  data-qa="search_filter_list"
                  style={{
                    borderBottom:
                      currentFilters.length > 10
                        ? `1px solid ${currentTheme?.borderColor || '#000000'}`
                        : 'none',
                    maxHeight: isYearsList
                      ? 'none'
                      : topTitle === 'productCategoriesList' || topTitle === 'sizesList'
                        ? '100%'
                        : '180px',
                    gap: isYearsList ? 4 : 0,
                    gridTemplateColumns: isYearsList ? 'repeat(3, 1fr)' : '',
                    marginTop: isYearsList ? 4 : '',
                    direction: 'ltr',
                    display: isYearsList ? 'grid' : 'block',
                  }}
                >
                  {currentFilters &&
                    currentFilters.map(
                      (productType: {
                        name: string;
                        gendersList?: any[];
                        productTypesList?: any[];
                        activitiesList?: any[];
                      }) => {
                        return (
                          <FilterItem
                            name={productType.name}
                            key={productType.name}
                            topTitle={topTitle}
                            isGender={topTitle === 'gendersList'}
                            isColor={topTitle === 'colorsList' ? productType.name : undefined}
                            kids={
                              topTitle === 'productCategoriesList'
                                ? productType.productTypesList || productType.activitiesList
                                : undefined
                            }
                            sizeList={productType.gendersList || []}
                            isYearsList={isYearsList}
                            isSizeList={isSizeList}
                            isRootCategory
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              hasTouchedFilters.current = true;
                              if (isSizeList) return;
                              let newQuery: any = { ...query, pageNumber: 1 };
                              const newTypes = new Set(selectedTypes);
                              if (newTypes.has(productType.name)) {
                                newTypes.delete(productType.name);
                                // since it's root category delete all types associated with it
                                if (productType.productTypesList) {
                                  const allkidsSet = new Set(
                                    ((query.types || '') as string).split(','),
                                  );

                                  productType.productTypesList.forEach((activity: any) => {
                                    allkidsSet.delete(activity.name);
                                  });

                                  newQuery = {
                                    ...newQuery,
                                    types: [...allkidsSet].join(','),
                                  };
                                }
                              } else {
                                newTypes.add(productType.name);
                              }

                              if (newTypes.size === 0) {
                                delete newQuery[queryName];
                              } else {
                                newQuery = {
                                  ...newQuery,
                                  [queryName]: [...newTypes].join(','),
                                };
                              }

                              sendTrackingEvent('FILTER_APPLY_TAP', {
                                service_name: 'consumer_search',
                                event_context: eventTrackingEventContext,
                                filter_name: queryName,
                                filter_selection: productType.name,
                                ...(getAppliedFilters(newQuery) && {
                                  applied_filters: getAppliedFilters(newQuery),
                                }),
                                ...(query?.query && { search_string: query.query.toString() }),
                              });

                              void router.push(
                                `${window.location.pathname}?${new URLSearchParams({
                                  ...newQuery,
                                  pageNumber: '1',
                                }).toString()}`,
                              );
                            }}
                          />
                        );
                      },
                    )}
                </div>
              ))}
          </div>
        );
      })}
    </div>
  );
};
